module.exports = function() {
  return new Worker(__webpack_public_path__ + "6135ca4c4aca0c182488.worker.js");
};